<template>

<div class="nav-menu bankari-dock" role="navigation" aria-label="Hlavná navigácia">
      
      <div class="left-top-bar">
        <div class="nav-link-block">
          <user-profile/>
        </div>
        <div class="nav-link-block">
          <button type="button"
            class="nav-link noselect link-icon-text"
            :class="[this.current === 'klienti' ? 'current' : '']"
            title="Klienti"
            @click="navigateTo('klienti')"
          >
            <app-icon class="nav-link-icon" name="users" :size="25" />
            klienti
          </button>
        </div>
        <div class="nav-link-block">
          <button type="button"
            class="nav-link noselect link-icon-text"
            :class="[this.current === 'hypoteky' ? 'current' : '']"
            title="Hypotéky"
            @click="navigateTo('hypoteky')"
          >
          <app-icon class="nav-link-icon" name="briefcase" :size="25" />
          hypotéky
          </button>
        </div>
<!--        <div class="nav-link-block">-->
<!--          <div-->
<!--            class="nav-link noselect link-icon-text"-->
<!--            :class="[this.current === 'servis' ? 'current' : '']"-->
<!--            @click="navigateTo('servis')"-->
<!--          >-->
<!--          <img class="nav-link-icon filter-primary" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f0c_icons8-business.svg"></img>-->
<!--          servis-->
<!--          </div>-->
<!--        </div>-->
        <!-- <div class="nav-link-block">
          <div
            class="nav-link noselect"
            @click="navigateTo('ziadosti')"
          >
          <img class="nav-link-icon filter-primary" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f0d_icons8-agreement.svg"></img>
          </div>
        </div> -->
        <div class="nav-link-block">
          <button type="button"
            class="nav-link noselect link-icon-text"
            :class="[this.current === 'servis' ? 'current' : '']"
            title="Servis"
            @click="navigateTo('servis')"
          >
            <app-icon class="nav-link-icon" name="clock" :size="25" />
            servis
          </button>
        </div>
        <div class="nav-link-block">
          <button type="button"
            class="nav-link noselect link-icon-text"
            title="Kalendár"
            @click="showCalendar()"
          >
          <app-icon class="nav-link-icon" name="calendar" :size="24" />
          kalendár
          </button>
        </div>
        <div class="nav-link-block">
          <button type="button"
            class="nav-link noselect link-icon-text"
            :class="[this.current === 'posudky' ? 'bl-color' : '']"
            title="Metodika"
            @click="openKnowHowPopUp"
          >
          <app-icon class="nav-link-icon" name="book" :size="25" />
          metodika
          </button>
        </div>
        <div v-if="role === 'alex_admin'" class="nav-link-block">
          <button type="button" class="nav-link noselect link-icon-text" :class="{current: current === 'marketing'}" title="Marketing" @click="navigateTo('marketing')">
            <app-icon class="nav-link-icon" name="megaphone" :size="25" />
            marketing
          </button>
        </div>
        <div v-if="role === 'alex_admin'" class="nav-link-block">
          <button type="button"
            class="nav-link noselect link-icon-text"
            :class="[this.current === 'nastavenia' ? 'current' : '']"
            title="Nastavenia"
            @click="navigateTo('nastavenia')"
          >
            <app-icon class="nav-link-icon" name="settings" :size="25" />
            nastavenia
          </button>
        </div>
        <!-- <div class="nav-link-block">
                   <div class="nav-link noselect">ZMLUVY</div>
        </div> -->
        <!-- <div class="nav-link-block">
          <div
            class="nav-link noselect"
            :class="[this.current === 'posudky' ? 'bl-color' : '']"
            @click="navigateTo('posudky')"
          >
            POSUDKY
          </div>
        </div> -->
      </div>
      
      <div v-show="!embeddedWorkspace" class="right-top-bar">
        <!-- <users-tasks-handler/> -->
        <button
          class="feedback-nav-button"
          :class="{'feedback-nav-button--unseen': hasUnseenUpdates}"
          type="button"
          :title="hasUnseenUpdates ? 'Máte novinku v aplikácii' : 'Novinky v aplikácii a spätná väzba'"
          :aria-label="hasUnseenUpdates ? 'Otvoriť novú aktualizáciu aplikácie' : 'Otvoriť novinky v aplikácii a spätnú väzbu'"
          @click="openUpdatesCenter"
        >
          <app-icon :name="hasUnseenUpdates ? 'bell' : 'info'" :size="23"/>
          <span v-if="hasUnseenUpdates" class="updates-unseen-badge" aria-hidden="true">1</span>
        </button>
        <notification-handler ref="notifications" :rules="['single']"/>
      </div>

      <audio id="new-notification" style="display: none" muted="muted">
        <source :src="require('@/sounds/new_message.mp3')" type="audio/mpeg"/>
      </audio>
    
    </div>

</template>

<script>
import router from "@/router";
import NotificationHandler from "../shared/PopupHandler/Popups/NotificationsManager/NotificationHandler";
import UserProfile from "../shared/UserProfile";
import UsersTasksHandler from "@/components/shared/PopupHandler/Popups/UsersTasks/UsersTasksHandler.vue";
import {isWorkspaceFrame} from "@/utils/brokerWorkspaces";
import AppIcon from "@/components/shared/AppIcon.vue";
import {latestProductUpdateId} from "@/data/productUpdates";

export default {
  name: "NavBarBroker",
  components: {AppIcon, UsersTasksHandler, UserProfile, NotificationHandler},
  watch: {
    $route (to) {
      this.current = to.path.split("/")[1].split("-")[1];
    },
  },
  mounted () {
    this.current = this.$route.fullPath.split("/")[1].split("-")[1];
    this.refreshUpdatesSeenState();
    this.workspaceUtilities = {
      getState: () => {
        this.refreshUpdatesSeenState();
        return {hasUnseenUpdates: this.hasUnseenUpdates, unseenMessages: this.$refs.notifications?.allUnseenMessages || 0,
          messagesReady: Array.isArray(this.$refs.notifications?.messages)};
      },
      open: kind => {
        if (kind === 'updates') this.openUpdatesCenter();
        if (kind === 'messages' && Array.isArray(this.$refs.notifications?.messages)) this.$refs.notifications.showNotificationPanel();
      },
    };
    window.__bankariWorkspaceUtilities = this.workspaceUtilities;
    window.addEventListener("bankari-product-updates-seen", this.refreshUpdatesSeenState);
  },
  created () {
    this.me = this.$store.getters["userState/getMe"];
    this.role = this.$store.getters["userState/getRole"];
  },
  beforeDestroy () {
    clearInterval(this.interval);
    clearInterval(this.mortgagesInterval);
    window.removeEventListener("bankari-product-updates-seen", this.refreshUpdatesSeenState);
    if (window.__bankariWorkspaceUtilities === this.workspaceUtilities) delete window.__bankariWorkspaceUtilities;
  },
  methods: {
    refreshUpdatesSeenState() {
      this.hasUnseenUpdates = window.localStorage.getItem("bankari-latest-product-update") !== latestProductUpdateId;
    },
    openUpdatesCenter() {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: null,
        component: "ProductUpdatesCenterPopUp",
        rules: ["single"],
      });
    },
    openKnowHowPopUp() {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: null,
        component: "KnowHowPopUp",
        rules: ['priority'],
      });
    },
    showCalendar () {
      this.$store.commit("appState/setCalendarVisible", true);
    },
    showNotificationPanel () {
      this.notificationOpen = true;
      setTimeout(() => {
        this.isClicked = true;
        this.isOpen = true;
      }, 100);
    },
    navigateTo(clicked) {
      this.mobileDropdownMenu = false;
      let finalLocation = "/karta-" + clicked;
      router.push(finalLocation).catch(() => {});
    },
  },
  data: () => ({
    me: null,
    role: null,
    embeddedWorkspace: isWorkspaceFrame(window),
    workspaceUtilities: null,
    mobileDropdownMenu: false,
    messageCounter: 0,
    interval: 0,
    mortgagesInterval: 0,
    isOpen: false,
    isClicked: false,
    notificationOpen: false,
    allUnseenMessages: 0,
    hasUnseenUpdates: false,
    current: "",
    brokerId: null,
    clientId: null,
  }),
};
</script>

<style scoped lang="scss">
.nav-menu.bankari-dock {
  box-sizing: border-box;
  right: auto !important;
  left: 50vw !important;
  width: max-content;
  max-width: calc(100vw - 48px);
  padding: 10px 12px;
  transform: translateX(-50%) !important;
  border-radius: 26px;
}

.bankari-dock .left-top-bar {
  min-width: 0;
  flex: 1 1 auto;
  justify-content: center;
}

.bankari-dock .nav-link-block {
  min-width: 0;
  margin: 0 4px;
  flex: 0 0 auto;
}

.bankari-dock .nav-link {
  width: 76px;
  min-width: 76px;
  padding: 8px 6px;
  gap: 5px;
  border: 0;
  background: transparent;
  font-family: inherit;
  font-size: 11px;
  line-height: 14px;
  white-space: nowrap;
}

.nav-link-icon {
  width: 25px;
  height: 25px;
  color: var(--app-primary);
}

.bankari-dock .right-top-bar {
  flex: 0 0 auto;
  gap: 8px;
  margin: -10px -12px -10px 4px;
  padding: 10px 14px;
  border-radius: 0 26px 26px 0;
}

.feedback-nav-button {
  position: relative;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background: var(--app-surface-muted);
  color: var(--app-primary);
  cursor: pointer;
}

.updates-unseen-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  border: 2px solid var(--app-surface);
  border-radius: 999px;
  background: #e45454;
  box-shadow: 0 3px 10px rgba(228, 84, 84, .34);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
}

.feedback-nav-button--unseen {
  border-color: rgba(84, 201, 151, .7);
  background: rgba(84, 201, 151, .12);
  animation: updates-attention 2.4s ease-in-out infinite;
}

@keyframes updates-attention {
  0%, 72%, 100% { transform: rotate(0); }
  78% { transform: rotate(-7deg); }
  84% { transform: rotate(7deg); }
  90% { transform: rotate(-4deg); }
  96% { transform: rotate(4deg); }
}

.bankari-dock .nav-link:focus-visible { outline: 2px solid var(--app-primary); outline-offset: -2px; }

.feedback-nav-button:hover,
.feedback-nav-button:focus-visible {
  border-color: var(--app-primary);
  background: var(--app-surface);
  outline: none;
}

@media (prefers-reduced-motion: reduce) {
  .feedback-nav-button--unseen { animation: none; }
}

@media (max-width: 900px) {
  .nav-menu.bankari-dock { max-width: calc(100vw - 24px); }
  .bankari-dock .link-icon-text { width: 46px; min-width: 46px; font-size: 0; line-height: 0; }
  .bankari-dock .left-top-bar { justify-content: flex-start; overflow-x: auto; scrollbar-width: none; }
  .bankari-dock .left-top-bar::-webkit-scrollbar { display: none; }
}

@media (max-width: 600px) {
  .bankari-dock .nav-link { width: 40px; min-width: 40px; padding: 6px 4px; }
  .bankari-dock .nav-link-block { margin: 0 1px; }
  .nav-link-icon { width: 22px; height: 22px; }
  .feedback-nav-button { width: 32px; height: 32px; }
  .bankari-dock .right-top-bar { gap: 4px; }
  .bankari-dock .right-top-bar {
    position: static;
    width: auto;
    height: auto;
    margin: -10px -12px -10px 2px;
    padding: 10px 8px;
    border: 0;
    box-shadow: none;
  }
}
</style>
